import Flex, { FlexProps } from '@/components/ui/Flex';
import Txt, { TxtProps } from '@/components/ui/Txt';
import { mergePropsClassName } from '@/lib/helpers';
import React from 'react';
import * as style from './BlockHeader.css';
import { BlockMeta } from '@/lib/parsers/blocks';

export type BlockHeaderProps = FlexProps<
  'div',
  {
    children?: React.ReactNode;
    className?: string;
    heading?: React.ReactNode;
    HeadingProps?: TxtProps;
    content?: React.ReactNode;
    ContentProps?: TxtProps;
    meta?: BlockMeta;
  } & style.BlockHeaderVariants
>;

const BlockHeader = ({
  children,
  heading,
  HeadingProps,
  content,
  ContentProps,
  maxWidth,
  meta: _meta,
  ...props
}: BlockHeaderProps) => {
  return (
    <>
      <Flex alignItems="start" {...mergePropsClassName(props, style.root({ maxWidth }))}>
        {heading && (
          <Txt variant="h2" as="h2" {...HeadingProps}>
            {heading}
          </Txt>
        )}
        {content && (
          <Txt as="div" variant="body" {...ContentProps} html>
            {content}
          </Txt>
        )}
        {children}
      </Flex>
    </>
  );
};

export default BlockHeader;
